import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Sparkles, LayoutDashboard, Inbox, Layers, Wallet, Truck, Ticket, User, LogOut, Bell, Image, MessageSquareQuote, Tag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const NAV = [
    { to: "/admin", label: "Visão geral", icon: LayoutDashboard, end: true },
    { to: "/admin/pedidos", label: "Pedidos", icon: Inbox },
    { to: "/admin/servicos", label: "Serviços & Preços", icon: Tag },
    { to: "/admin/precos", label: "Suplementos & Extras", icon: Wallet },
    { to: "/admin/deslocacao", label: "Taxas de deslocação", icon: Truck },
    { to: "/admin/promocoes", label: "Códigos promocionais", icon: Ticket },
    { to: "/admin/galeria", label: "Galeria", icon: Image },
    { to: "/admin/testemunhos", label: "Testemunhos", icon: MessageSquareQuote },
    { to: "/admin/notificacoes", label: "Notificações", icon: Bell },
    { to: "/admin/conta", label: "A minha conta", icon: User },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const doLogout = async () => {
        await logout();
        navigate("/admin/login");
    };
    return (
        <div className="min-h-screen bg-[#0A0A0A] text-white flex">
            <aside className="w-64 bg-[#0A0A0A] border-r border-[#2A2A2A] hidden lg:flex flex-col">
                <div className="p-6 border-b border-[#2A2A2A] flex items-center gap-3">
                    <Logo variant="full" size={40} />
                </div>
                <nav className="flex-1 p-3 space-y-1">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            data-testid={`nav-${item.to.split("/").pop() || "overview"}`}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors uppercase tracking-wider text-xs ${isActive ? "bg-[#C9A961]/10 text-[#C9A961] border-l-2 border-[#C9A961]" : "text-white/60 hover:bg-[#171717] hover:text-white"}`
                            }
                        >
                            <item.icon className="w-4 h-4" />
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="p-3 border-t border-[#2A2A2A]">
                    <div className="px-3 py-2 mb-2">
                        <div className="text-[10px] text-white/40 uppercase tracking-widest">Sessão</div>
                        <div className="text-sm font-medium text-white truncate">{user?.email}</div>
                    </div>
                    <Button variant="ghost" onClick={doLogout} className="w-full justify-start text-white/70 hover:bg-[#171717] hover:text-white uppercase tracking-wider text-xs" data-testid="logout-btn">
                        <LogOut className="w-4 h-4 mr-2" /> Sair
                    </Button>
                </div>
            </aside>
            <div className="flex-1 flex flex-col min-w-0">
                <header className="lg:hidden bg-[#0A0A0A] border-b border-[#2A2A2A] px-4 py-3 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Logo variant="full" size={32} />
                    </div>
                    <Button size="sm" variant="ghost" onClick={doLogout} className="text-white/70 hover:bg-[#171717]"><LogOut className="w-4 h-4" /></Button>
                </header>
                <div className="lg:hidden bg-[#0A0A0A] border-b border-[#2A2A2A] overflow-x-auto">
                    <div className="flex px-2 gap-1 py-2 min-w-max">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                className={({ isActive }) =>
                                    `flex items-center gap-1.5 px-3 py-1.5 rounded-sm text-xs font-medium whitespace-nowrap uppercase tracking-wider ${isActive ? "bg-[#C9A961]/10 text-[#C9A961]" : "text-white/60"}`
                                }
                            >
                                <item.icon className="w-3.5 h-3.5" />
                                {item.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
                <main className="flex-1 p-6 lg:p-10 overflow-auto bg-[#0A0A0A]">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
